import { render, staticRenderFns } from "./ImageRotationForm.vue?vue&type=template&id=08e5235c&scoped=true&"
import script from "./ImageRotationForm.vue?vue&type=script&lang=ts&"
export * from "./ImageRotationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ImageRotationForm.vue?vue&type=style&index=0&id=08e5235c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5235c",
  null
  
)

export default component.exports